import React from "react";

function TabelaCustosIndiretos({ meses }) {
    const custoMap = new Map();

    Object.entries(meses).forEach(([mesAno, mesData]) => {
        mesData.previstoIndireto?.forEach(item => {
            const key = JSON.stringify({
                tipo: item.tipo,
                descricao: item.descricao_custo_indireto,
            });

            if (!custoMap.has(key)) {
                custoMap.set(key, {
                    tipo: item.tipo,
                    descricao: item.descricao_custo_indireto,
                    valoresPorMes: {},
                    total: 0,
                });
            }

            const entry = custoMap.get(key);
            const valor = parseFloat(item.valor_custo_indireto);
            entry.valoresPorMes[mesAno] = (entry.valoresPorMes[mesAno] || 0) + valor;
            entry.total += valor;
        });
    });

    // Totais por mês e total geral
    const totalPorMes = {};
    let totalGeral = 0;

    custoMap.forEach(item => {
        Object.entries(item.valoresPorMes).forEach(([mes, valor]) => {
            totalPorMes[mes] = (totalPorMes[mes] || 0) + valor;
            totalGeral += valor;
        });
    });

    return (
        <tbody>
            {Array.from(custoMap.values()).map((item, idx) => (
                <tr key={idx}>
                    <td>{item.tipo}</td>
                    <td>{item.descricao}</td>
                    {Object.keys(meses).map((mesAno, i) => (
                        <td key={i}>
                            {item.valoresPorMes[mesAno] !== undefined
                                ? item.valoresPorMes[mesAno].toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                })
                                : '-'}
                        </td>
                    ))}
                    <td>
                        {item.total.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </td>
                </tr>
            ))}
            <tr>
                <td><strong>Total</strong></td>
                <td></td>
                {Object.keys(meses).map((mesAno, i) => (
                    <td key={i}>
                        <strong>
                            {(totalPorMes[mesAno] || 0).toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                            })}
                        </strong>
                    </td>
                ))}
                <td>
                    <strong>
                        {totalGeral.toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </strong>
                </td>
            </tr>
        </tbody>
    );
}

export default TabelaCustosIndiretos;
